/* eslint-disable import/no-extraneous-dependencies -- @react-aria/focus. */
import { LayoutProvider, Layout as MainLayout, NavigationWrapper } from '@eleveo/components-react';
import React from 'react';
import { OverlayProvider } from 'react-aria';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { DrawerSideBox } from './drawer/DrawerSideBox';
import { DrawerSideBoxContent } from './drawer/DrawerSideBoxContent';
import { DrawerSideBoxFooter } from './drawer/DrawerSideBoxFooter';
import { DrawerSideBoxHandle } from './drawer/DrawerSideBoxHandle';
import { DrawerSideBoxHeader } from './drawer/DrawerSideBoxHeader';
import { Navigation } from './navigation/Navigation';

export const Layout: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MainLayout>
      <Helmet>
        <title>{t('applications.ETLManagement')}</title>
      </Helmet>
      <NavigationWrapper>
        <OverlayProvider>
          <DrawerSideBox>
            <DrawerSideBoxHeader>{t('applications.abbreviations.ETLManagement')}</DrawerSideBoxHeader>
            <DrawerSideBoxContent>
              <Navigation />
            </DrawerSideBoxContent>
            <DrawerSideBoxFooter />
            <DrawerSideBoxHandle />
          </DrawerSideBox>
        </OverlayProvider>
      </NavigationWrapper>

      <LayoutProvider>
        <Outlet />
      </LayoutProvider>
    </MainLayout>
  );
};
